// extracted by mini-css-extract-plugin
module.exports = {"number":"range-error_number__286fc","text":"range-error_text__1YcAw"};